import { Component } from '@angular/core';

@Component({
  selector: 'app-lista-importacoes-pessoas',
  imports: [],
  templateUrl: './lista-importacoes-pessoas.html',
  styleUrl: './lista-importacoes-pessoas.scss'
})
export class ListaImportacoesPessoas {

}
